import React from 'react';
import { Grid, Paper, Typography, Box } from '@mui/material';
import { BieMoney } from './BieValue';

type Props = { cards?: any };

const cardMap = [
  ['hydrocarbonsales', 'Hydrocarbon Sales'],
  ['hydrocarbonpurchases', 'Hydrocarbon Purchases'],
  ['commercialmargin', 'Commercial Margin'],
  ['partialresult', 'Partial Result'],
  ['budgetcapacity', 'Budget Capacity'],
  ['financialproducts', 'Financial Products'],
];

class DashboardCards extends React.PureComponent<Props> {
  render() {
    const { cards = {} } = this.props;
    return (
      <Grid container spacing={2}>
        {cardMap.map(([key, label]) => (
          <Grid size  = {{ xs:12, sm: 6, md: 4}} key={key}>
            <Paper elevation={1} sx={{ p: 2, height: '100%' }}>
              <Typography variant="caption" color="text.secondary">{label}</Typography>
              <Box sx={{ mt: 1 }}>
                <Typography variant="h5" fontWeight={700}>
                  <BieMoney value={cards[key]} />
                </Typography>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
    );
  }
}

export default DashboardCards;
